document.addEventListener("DOMContentLoaded", () => {
    let lightboxOpen = false;
    let lightbox = document.querySelector("#blogArchive__videoLightbox");
    let bgVideo = document.querySelector("#blogArchive__bgVideo");
    let lbVideo = document.querySelector("#blogArchive__videoLightbox-video");

    document.querySelector("#blogArchive__play").addEventListener("click", () => {
        if(!lightboxOpen) {
            bgVideo.pause();
            lightbox.showModal();
            lightboxOpen = true;
        }
    });

    lightbox.addEventListener("click", (e) => {
        if (e.target.id != "blogArchive__videoLightbox-video") {
            lbVideo.pause();
            bgVideo.play();
            lightbox.close();
            lightboxOpen = false;
        } 
    });

    document.addEventListener("keydown", (e) => {
        if(lightboxOpen && e.keyCode == "27") {
            lbVideo.pause();
            bgVideo.play();
            lightbox.close();
            lightboxOpen = false;
        } 
    });
});